import * as SDK from '@replai-platform/sdk';
import * as provider from './provider';
/**
 * Get networks
 */
export async function getNetworks(request: SDK.GetNetworksRequest): Promise<SDK.GetNetworksResponse> {
  return provider.getJson(`${SDK.BASE_URL()}/networks?${SDK.convertRequestToQueryParams(request)}`);
}
